import getGraphQlClient from '~graphql/getGraphQlClient';
import { unmarshalGraphqlResponse } from '~graphql/utils';
import { FETCH_ALLEGATI } from '../../queries/allegati';

export default async function fetchAllegati(
  where = {},
  order = [],
  first = 100
) {
  const graphQlClient = await getGraphQlClient();

  const result = await graphQlClient.query({
    fetchPolicy: 'network-only',
    variables: {
      where,
      order,
      first,
    },
    query: FETCH_ALLEGATI,
  });

  const allegati = await unmarshalGraphqlResponse(result.data, 'allegatis')
    .edges;

  return allegati;
}
